import dayjs from "dayjs";

import { fmtDateTime } from "@/components/show";
// Registers dayjs's utc and timezone plugins, which `formatStart` needs.
import "@/lib/dateUtils";

/**
 * An event's start on its own wall clock, so a curator in Athens reads a New York show as New
 * York does. A missing or unknown timezone falls back to the browser's.
 */
export function formatStart(iso: string, timezone?: string): string {
  if (timezone) {
    try {
      return dayjs(iso).tz(timezone).format("DD MMM YYYY, HH:mm");
    } catch {
      // An unknown zone name: show the browser-local time rather than nothing.
    }
  }
  return fmtDateTime(iso);
}
